import { createCRUDHook } from './createCRUDHook';
import { PermissionDto } from 'utils/models';
import { TLKP_PERMISSIONS } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<PermissionDto>({
  entityName: 'Permission',
  endpoint: TLKP_PERMISSIONS,
});

export const PermissionContext = Context;
export const usePermissionManager = useManager;
export const usePermission = useConsumer;
